module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/structure_logo-307d872fa817b4a87bdf951025077a44.png";